import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  categories: hasMany('category', { inverse: null }),
  channelsAdditive: hasMany('channel', { inverse: null }),
  channelsExcluded: hasMany('channel', { inverse: null }),
  channelsExclusive: hasMany('channel', { inverse: null }),
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  cmsOwnerId: belongsTo('user', { inverse: null }),
  contributors: hasMany('product-family-contributor', {
    inverse: 'productFamily',
  }),
  ownedByChannel: belongsTo('channel', { inverse: null }),
  products: hasMany('product', { inverse: null }),
  seoImage: belongsTo('asset', { inverse: null }),
  taxa: hasMany('taxon', { inverse: null }),
  webSeries: hasMany('web-series', { inverse: null }),
});
